let lastGeneratedUid = 1;
export const generateUID = () => ++lastGeneratedUid;
